import {
  CHAVES_ILUSTRACAO,
  ROTULOS_ILUSTRACAO,
  urlIlustracao,
} from "../lib/catalogoImagens";

/**
 * Grade pra escolher uma ilustração do catálogo (imagem padrão da ferramenta).
 * Chama onPick com a ref "cat:<chave>". `selecionada` destaca a atual.
 */
export function SeletorCatalogo({
  selecionada,
  onPick,
}: {
  selecionada?: string | null;
  onPick: (ref: string) => void;
}) {
  return (
    <div className="cat-grade">
      {CHAVES_ILUSTRACAO.map((chave) => {
        const ref = `cat:${chave}`;
        const sel = selecionada === ref;
        return (
          <button
            type="button"
            key={chave}
            className={`cat-item${sel ? " sel" : ""}`}
            title={ROTULOS_ILUSTRACAO[chave]}
            aria-pressed={sel}
            onClick={() => onPick(ref)}
          >
            <img src={urlIlustracao(ref)} alt={ROTULOS_ILUSTRACAO[chave]} />
            <span>{ROTULOS_ILUSTRACAO[chave]}</span>
          </button>
        );
      })}
    </div>
  );
}
